<template>
    <el-date-picker :value-format="valueFormat" :format="format" v-on="$listeners" v-bind="$attrs"
        :value="value" @change="(val)=>{$emit('input',val)}" :editable="false" :clearable="false"></el-date-picker>
</template>

<script>
export default {
    name: 'CDatePicker',
    inheritAttrs: false,
    props: {
        value: {
            required: false
        }
    },
    data() {
        return {
            valueFormat: this.$attrs.type === 'datetime' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd',
            format: this.$attrs.type === 'datetime' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'
        }
    },
    created() {
        console.log()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/global/CDatePicker.vue